import { render, staticRenderFns } from "./Gratitude.vue?vue&type=template&id=433eb27f&scoped=true"
var script = {}
import style0 from "./Gratitude.vue?vue&type=style&index=0&id=433eb27f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433eb27f",
  null
  
)

export default component.exports